import { type Response } from "@/types/shared";

export function validateEmail(email: string): Response<[]> {
    // If empty string return false
    if (email === "") {
        return {
            status: false,
            message: "Please enter your email address",
        };
    }
    // Email validation regex that:
    // 1. Local part cannot start with dot
    // 2. Local part cannot have consecutive dots
    // 3. Local part can only contain certain characters
    // 4. Must have exactly one @
    // 5. Domain cannot start with dot
    // 6. Domain parts can only contain letters, numbers, hyphens
    // 7. Domain parts cannot start/end with hyphen
    // 8. Must have at least one dot in domain
    // 9. Last domain part must be at least 2 chars
    if (/^(([[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?))$/.test(email.toLocaleLowerCase())) {
        return { status: true, data: [] };
    }
    return {
        status: false,
        message: "Email is invalid. Please check your input and try again.",
    };
}
